// extracted by mini-css-extract-plugin
export default {"nothing":"Customcss_nothing__-yEHk"};